<template>
  <div class="pub-page-title">
    <div class="pub-page-title-title">{{ title }}</div>
    <div class="pub-page-title-option"><slot name="titleRight"></slot></div>
  </div>
</template>

<script>
export default {
  name: "PubPageTitle",
  props: {
    title: String,
  },
};
</script>

<style scoped lang="less">
.pub-page-title {
  border-bottom: 1px solid @border-color;
  padding: 0 20px;
  line-height: 50px;
  font-size: 16px;
  position: relative;
  display: flex;
  &::after {
    content: "";
    height: 15px;
    border-right: 3px solid @blue;
    position: absolute;
    left: 5px;
    top: 17px;
  }
  .pub-page-title-title {
    flex: 1;
  }
}
</style>
